import { render, staticRenderFns } from "./DownloadTenderTextButton.vue?vue&type=template&id=53661f70"
import script from "./DownloadTenderTextButton.vue?vue&type=script&lang=js"
export * from "./DownloadTenderTextButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports